<template>
  <div class="footer">
    <div class="columns is-vcentered">
      <div class="column is-offset-one-third is-one-third has-text-centered">
        <img src="~@/assets/footer_logo.png" class="logo" alt="The Home Depot Pro - A Home Depot Company">
      </div>
      <div class="column has-text-right">
        <small>{{ version }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterBar',
  computed: {
    version() {
      return `v${process.env.version}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FooterLogo.vue